module.exports = __webpack_public_path__ + "img/normal-big.d1a87c27.svg";